import { Navigate } from "react-router-dom";
import { ROUTES } from "../../lib/constants.js";
import { useUser } from "../UserContext.js";

export default function AdminRoute({ children }) {
  const { isAdmin, runId } = useUser();

  if (isAdmin) {
    return children;
  }

  return <Navigate to={ROUTES.BASE.replace(":id", runId)} replace />;
}
